const req = require.context('.', false, /\.(png|jpe?g|svg|webp)$/);

export const AVATAR_LIST = req.keys().map(req);